import * as jsxRuntime from "/Users/natalie/Desktop/Development/peekapak-platform.release.2026.10.21/apps/frontend/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment